import React from "react";
import { PlaceOrderData } from "@swiggy-private/checkout-core";

export interface PlaceOrderContextValue {
    placeOrderInProgress: boolean;
    processingOrder: boolean;
    placeOrderData?: PlaceOrderData;
    doPlaceOrder: (data: NonNullable<PlaceOrderData>) => void;
    isPlaceOrderHookMounted: boolean;
}

export const PlaceOrderContext = React.createContext<PlaceOrderContextValue>({
    placeOrderInProgress: false,
    doPlaceOrder: () => void 0,
    processingOrder: false,
    isPlaceOrderHookMounted: false,
});

if (__DEV__) {
    PlaceOrderContext.displayName = "PlaceOrderContext";
}
